module.exports = __webpack_public_path__ + "static/media/call-us.c67c0c6a.svg";